import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'

import config from '../../config/config'
import PoiExternalLink from './PoiExternalLink'

const PoiExternalLinks = ({ poi, isAdmin }) => {
  const { t } = useTranslation()
  const [poiExternalLinks, setPoiExternalLinks] = useState([])

  useEffect(() => {
    const fetchPoiExternalLinks = async () => {
      try {
        const response = await axios.get(
          `${config.apiUrl}poi-external-link?poi=${poi.id}&isAffiliateLink=false`,
        )
        setPoiExternalLinks(response.data)
      } catch (error) {
        // console.error('An error occurred while fetching links:', error);
      }
    }

    fetchPoiExternalLinks()
  }, [poi.id])

  return (
    <div>
      {poiExternalLinks && poiExternalLinks.length > 0 && (
        <div className="mt-4">
          <hr />
          <h2 className="mb-4">{t('SEE_ELSEWHERE')}</h2>
          <div className="d-flex flex-column gap-3">
            {poiExternalLinks.map((poiExternalLink) => (
              <PoiExternalLink
                key={poiExternalLink.id}
                poiExternalLink={poiExternalLink}
                isAdmin={isAdmin}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default PoiExternalLinks
